export default {
    Language:'English',
    ContactUs:'Contact Us',
    EnterpriseWeChat:'WeChat',
    OnlineConsultant:'Online',
    OnLineService:'Online message',
    ViewAll:'View All',
    HotRecommends:'Hot Recommends',
    ViewDetails:'View Details',
    WhatCanWeDoForYou:'What can we do for you',
    Detail:'Detail',
    Contact:'Contact',
    RelevantPolicyTrends:'Relevant policy trends',
    MoreDynamic:'More Dynamic',
    LoyaltyToDataWinsTrust:'Adhere to truth,gain the reliance',
    Customers:'Customers',
    Business:'Business',
    OfficialAccounts:'Official Accounts',
    Douyin:'TikTok',
    FriendlyLink:'Friendly Link',
    AllRightsReserved:'All rights reserved',
    CompanyName:'XIANGYANG DAAN AUTOMOBILE TEST CENTER CORPORATION LIMITED',
    Overview:'Overview',
    CoreAdvantage:'Core Advantage',
    CharacteristicCase:'Characteristic Case',
    MainContent:'Main Content',
    MajorOrientation:'Major Orientation',
    Close:'Close',
    ContactNumber:'contact number',
    Home:'Home',
    Search:'Search',
    CoreCompetencies:'Core competencies',
    CharacteristicAdvantage:'Characteristic advantage',
    ExcellentCase:'Excellent case',
    TechnologyConsulting:'Technology consulting',
    LoadMore:'Load more',
    NoData:'No data',
    Source:'Source',
    GoBack:'GoBack',
    PublishTime:'Publish time',
    DAANVOICE:"The Voice of Da 'an",
    RECENTNEWS:'Recent news',
    MORE:'More',
    ADDRESS:'Address',
    People:'People',
    ResumeDownload:'Resume download',
    JoinDaan:'Join Daan',
    JoinDes:'We sincerely recruit senior expert talents of various specialties to the world, and provide a good scientific research environment and innovation soil in all aspects',
    EmployeeActivity:'Employee activity',
    EmployeeActivityDes:'Jointly build a world-class automobile technical service enterprise',
    StaffPresence:'Staff presence',
    StaffPresenceDes:'Jointly build a world-class automobile technical service enterprise',
    TalentStrategy:'Talent strategy',
    TalentStrategyDes:'We sincerely recruit senior expert talents of various specialties to the world, and provide a good scientific research environment and innovation soil in all aspects',
    LearnMore:'Learn more',
    JoinUs:'Join Us',
    JoinUsDes:'Invite you to [Build a world-class automobile technical service enterprise]',
    Delivery:'Delivery',
    DownloadResumeTemplate:'Download resume template',
    Founded:'Founded',
    FloorSpace:'Floor space',
    CurrentStaff:'Current staff',
    Detectability:'Detectability',
    Year:'Year',
    HistoricalDevelopment:'Historical Development',
    InstitutionalAccreditation:'Institutional Accreditation',
    EnterKeywordsToSearchForJobs:'Enter keywords to search for jobs',
    ServiceScope:'Service scope',
    ServicePromise:'Service Promise',
    OneStopShop:'one-stop service',
    BusinessDivision:"Xiangyang headquarters, Wuhan Subsidiary, work Department/overseas business department",
    InputKeyword:'Please enter a keyword',
    DeliveryEmail:'Delivery Email',
    Governmentwebsite:'Government website',
    CentralNetworkGroup:'Central Network Group',
    IndustryBody:'Industry body',
    Send:'Send',
    PleaseEnter:'Please enter text',
    EnterpriseCentralPartner:'Enterprise Central Partner',
    CarPartner:'Car Partner',
    Me:'my',
    ClienteleServices:'Technical advice',
    BrandIntroduction:'Brand Introduction',
    OffRoadGuideDatabase:'China Off-Road Road Map Guide',
    DownloadCenter:'Download  Resource',
    LatestUpdates:'Latest News',
    LatestEvaluationModel:'Latest Vehicle/Route Evaluations (Coming Soon)',
    ViewAllResults:'View All Results',
    RegulationsFileDownload:'Regulations file downloadRegulation Documents Download',
    DownloadEvaluationResults:'Test Results Download',
    ViewMore:'View more',
    More:'More',
    FrontlineEvaluation:'Test Frontline',
    EvaluationModelAnnounced:'Announced Test Vehicles',
    MediaReports:'Media Coverage',
    IndustryNews:'Industry News',
    Download:'Download',

}